import { type Variants } from 'framer-motion';
import { type GlobalToken } from 'antd';

export const variants: Variants = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 20,
    }
  },
};

export const staggeredContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const staggeredItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const createRandomColorVariants = (token: GlobalToken): Variants => ({
  initial: { color: token.colorPrimary },
  animate: {
    color: [token.colorPrimary, token.colorSuccess, token.colorWarning, token.colorError, token.colorPrimary],
    transition: {
      duration: 4,
      repeat: Infinity,
      repeatType: "loop",
      ease: "linear",
      delay: Math.random() * 2,
    }
  }
});

export const createRandomBorderColorVariants = (token: GlobalToken): Variants => ({
    initial: { color: token.colorPrimary, borderLeftColor: token.colorPrimary },
    animate: {
      color: [token.colorPrimary, token.colorSuccess, token.colorWarning, token.colorError, token.colorPrimary],
      borderLeftColor: [token.colorPrimary, token.colorSuccess, token.colorWarning, token.colorError, token.colorPrimary],
      transition: {
        duration: 4,
        repeat: Infinity,
        repeatType: "loop",
        ease: "linear",
        delay: Math.random() * 2,
      }
    }
  });